import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";
import { ENRefData } from "../domain/ENRefData";
import { genericRefDataMap, genericRefDataSort } from "./helpers";

export class AssessmentWhenIdentifiedService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/amewhenidentifiedoptions`;
    const data = await super.getRequest<ENRefData[]>(url, opts);
    return genericRefDataMap(genericRefDataSort(data));
  }
}
